import FlatCard from "components/UI-lib/FlatCard";
import { AreaChart } from "../../../Graphs/AreaGraph";
import React, { useMemo, useState } from "react";
import { UsageOverview } from "server";
import { monthNames } from "components/utils";

interface UsageOverviewChartProps {
  usageData: {
    [key: string]: UsageOverview[];
  };
}
const UsageOverviewChart: React.FC<UsageOverviewChartProps> = ({
  usageData,
}) => {
  const category = "Total GPU Hours";

  const chartData = useMemo(() => {
    const dataLookup: { [key: string]: { totalHours: number; date: Date } } = {};

    Object.entries(usageData).forEach(([_, usage]) => {
      usage.forEach((item) => {
        const utcDate = new Date(item.Date);
        const dateString = utcDate
          .toUTCString()
          .split(" ")
          .slice(0, 4)
          .join(" ");
        if (!dataLookup[dateString]) {
          dataLookup[dateString] = {
            totalHours: 0,
            date: utcDate,
          };
        }
        dataLookup[dateString].totalHours += item.TotalTime / 3600;
      });
    });

    return Object.values(dataLookup)
      .sort((a, b) => a.date.getTime() - b.date.getTime())
      .map(({ totalHours, date }) => ({
        date: `${monthNames[date.getUTCMonth()]} ${date.getUTCDate()}`,
        [category]: totalHours,
      }));
  }, [usageData]);

  return (
    <FlatCard noBorder={true}>
      <div className="flex flex-col gap-4">
        <div className="flex flex-col">
          <h1 className="text-xl text-white font-semibold">
            GPU Hours Consumed
          </h1>
        </div>
        <AreaChart
          className="h-80"
          data={chartData}
          index="date"
          categories={[category]}
          intervalType="preserveStartEnd"
          valueFormatter={(value) => value.toFixed(1)}
        />
      </div>
    </FlatCard>
  );
};

export default UsageOverviewChart;
